import NavbarDesktop from './NavbarDesktop';
import useScreenWidth from './../../hooks/useScreenWidth';
import NavbarMobile from './NavbarMobile';

const Navbar = () => {
  const screenWidth = useScreenWidth();

  return <div>{screenWidth > 576 ? <NavbarDesktop /> : <NavbarMobile />}</div>;
};

export default Navbar;
